module.exports = __webpack_public_path__ + "img/solution-bg.75807793.png";